import { useEffect, useRef, useState } from "react";
import { logoRow } from "@/lib/svg";

export default function SyncScreen({ name, onDone }) {
  const [pct, setPct] = useState(8);
  const logo = useRef(logoRow(1.15)).current;

  useEffect(() => {
    const t1 = setTimeout(() => setPct(100), 120);
    const t2 = setTimeout(onDone, 1500);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="sync" data-testid="login-sync-screen">
      <div className="sync-card sync-card-min">
        <div className="logo-row sync-logo" dangerouslySetInnerHTML={{ __html: logo }} />
        <div className="sync-bar"><div className="sync-bar-fill" style={{ width: pct + "%" }} /></div>
        <div className="sync-sub-min">Loading your accounts…</div>
      </div>
    </div>
  );
}
